import { useEffect, useRef, useState } from 'react';

import _ from 'lodash';

import VideoPreview from 'components/VideoPreview';
import { ENUM_QUESTION_TYPE } from 'constants/enum';
import { CATEGORY_VIDEOS_ASE, VIDEO_TUTORIAL } from 'constants/index';
import { TEXT_COMMON, TEXT_CREATE_SURVEY, TEXT_RESULT_REPORT } from 'constants/string/texts';
import { getScrollableParent, isElementInView } from 'utils/helper';

import ParagraphOption from './ParagraphOption';
import RadioCheckbox from './RadioCheckbox';

const AddVideoAlternate = require('assets/resources/AddVideoAlternate.svg').default;
const Arrow = require('assets/resources/Arrow.svg').default;
const PlayVideo = require('assets/resources/PlayVideo.svg').default;
const Required = require('assets/resources/Required.svg').default;

const VideoCategory = (props) => {
  const { data, isPreview } = props;

  const [isShowTutorial, setIsShowTutorial] = useState(true);
  const [heightTutorial, setHeightTutorial] = useState(0);
  const tutorialRef = useRef(null);

  const [isShowCheckpoints, setIsShowCheckpoints] = useState(true);
  const [dataCheckpoints, setDataCheckpoints] = useState([]);
  const [heightCheckpoints, setHeightCheckpoints] = useState(0);
  const checkpointsRef = useRef(null);

  const videoTutorialKey = Object.keys(VIDEO_TUTORIAL);
  const indexVideoTutorial = videoTutorialKey.findIndex((item) => item === data.title);

  const videoCategoryKey = Object.keys(CATEGORY_VIDEOS_ASE);
  const indexVideoCategory = videoCategoryKey.findIndex((item) => item === data.title);

  useEffect(() => {
    if (tutorialRef.current) {
      setHeightTutorial(tutorialRef.current.scrollHeight);
    }
  }, [tutorialRef.current]);

  useEffect(() => {
    if (checkpointsRef.current) {
      setHeightCheckpoints(checkpointsRef.current.scrollHeight);
    }
  }, [checkpointsRef.current]);

  const handleCheckpoints = () => {
    if (data.video_category && data.video_category.checkpoints && data.video_category.checkpoints.length > 0) {
      const dataCheckpoints = {
        question_type: ENUM_QUESTION_TYPE.CHECKBOX,
        options: data.video_category?.checkpoints?.map((item) => ({
          option_text: item?.description,
          id: item?.id,
        })),
        answer: _.filter(data.video_category?.checkpoints, { status: true })?.map((item) => item.id),
      };
      setDataCheckpoints(dataCheckpoints);
    } else {
      const dataCheckpoints = {
        question_type: ENUM_QUESTION_TYPE.CHECKBOX,
        options: CATEGORY_VIDEOS_ASE[videoCategoryKey[indexVideoCategory]]?.map((item, index) => ({
          option_text: item,
          id: index,
        })),
        answer: [],
      };
      setDataCheckpoints(dataCheckpoints);
    }
  };

  useEffect(() => {
    handleCheckpoints();
  }, [data.video_category]);

  if (indexVideoTutorial === -1 && indexVideoCategory === -1) {
    return <></>;
  }

  return (
    <div className={`flex ${isPreview ? 'flex-col' : ''} gap-6 mt-3`}>
      <div className={`${isPreview ? 'w-full' : 'w-1/2'}`}>
        {indexVideoTutorial !== -1 && (
          <>
            <div className="py-3 border-b border-solid border-black/10 flex justify-between items-center">
              <p className="font-bold text-black/85">{TEXT_RESULT_REPORT.VIDEO_TUTORIAL}</p>
              <img
                src={Arrow}
                alt="image"
                width={16}
                height={16}
                className={`cursor-pointer ${isShowTutorial ? 'rotate-180' : ''}`}
                onClick={() => setIsShowTutorial(!isShowTutorial)}
              />
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${!isShowTutorial ? '!max-h-0' : ''}`}
              style={{ maxHeight: heightTutorial === 0 ? 'auto' : heightTutorial }}
              ref={tutorialRef}
            >
              <ul className="pt-4">
                {VIDEO_TUTORIAL[videoTutorialKey[indexVideoTutorial]]?.map((item, index) => (
                  <li key={`video-${index}`} className="text-black-102">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </>
        )}
      </div>
      <div className={`${isPreview ? 'w-full' : 'w-1/2'}`}>
        {indexVideoCategory !== -1 && (
          <>
            <div className="py-3 border-b border-solid border-black/10 flex justify-between items-center">
              <p className="font-bold text-black/85">{TEXT_RESULT_REPORT.VIDEO_CATEGORY}</p>
              <img
                src={Arrow}
                alt="image"
                width={16}
                height={16}
                className={`cursor-pointer ${isShowCheckpoints ? 'rotate-180' : ''}`}
                onClick={() => setIsShowCheckpoints(!isShowCheckpoints)}
              />
            </div>
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${!isShowCheckpoints ? '!max-h-0' : ''}`}
              style={{ maxHeight: heightCheckpoints === 0 ? 'auto' : heightCheckpoints }}
              ref={checkpointsRef}
            >
              <div className="pt-4">
                <RadioCheckbox data={dataCheckpoints} isPreview={false} viewOnly={true} />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

const VideoOption = (props) => {
  const { data } = props;

  const [isOpen, setIsOpen] = useState(-1);
  const [showVideo, setShowVideo] = useState(false);
  const videoContainerRef = useRef(null);

  const videoCategoryKey = Object.keys(CATEGORY_VIDEOS_ASE);
  const indexVideoCategory = videoCategoryKey.findIndex((item) => item === data.title);

  useEffect(() => {
    const check = () => {
      if (isElementInView(videoContainerRef.current)) {
        setShowVideo(true);
      }
    };
    const scrollableParent = getScrollableParent(videoContainerRef.current);
    if (scrollableParent) {
      scrollableParent.addEventListener('scroll', check);
    }
    return () => {
      if (scrollableParent) {
        scrollableParent.removeEventListener('scroll', check);
      }
    };
  }, []);

  return (
    <>
      <div className="flex items-center gap-2">
        <img src={AddVideoAlternate} alt="add video" width={36} height={36} />
        {data.is_required && <img src={Required} alt="required" width={7} height={7} />}
        {indexVideoCategory === -1 ? (
          <span className="text-black-102">
            {TEXT_CREATE_SURVEY.UPLOAD_VIDEO_INSTRUCTION.replace('{max_video}', data?.meta_data?.max_upload_files ?? 5)}
          </span>
        ) : (
          <span className="text-black-102">
            {data.question_number ? TEXT_COMMON.QUESTION_NUMBER.replace('${question_number}', data.question_number) : ''}{' '}
            <span className="font-bold">{data?.title || ''}</span>
          </span>
        )}
      </div>
      {data.media_files?.length > 0 && (
        <div className="flex flex-wrap gap-4 mt-4" ref={videoContainerRef}>
          {data.media_files.map((item, index) => (
            <div
              key={`video-${index}`}
              className="max-w-60 flex justify-start items-start rounded overflow-hidden relative"
              onClick={() => setIsOpen(index)}
            >
              {showVideo && (
                <>
                  {item.thumbnail_url ? (
                    <img src={item.thumbnail_url} alt="thumbnail" className="w-full h-full object-cover" />
                  ) : (
                    <video autoPlay={false} controls={false} className="w-full h-full object-cover">
                      <source src={item.url} type="video/mp4" />
                    </video>
                  )}
                  <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
                    <img src={PlayVideo} alt="play video" width={56} height={56} />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      )}
      <VideoCategory {...props} />
      <div className="mt-4 p-6 rounded-lg border border-solid border-gray-489">
        <p className="text-black-102 font-bold text-sm mb-6">{TEXT_CREATE_SURVEY.TEXT_IF_YOU_UPLOAD_VIDEO}</p>
        <p className="text-black-102 mb-4">{TEXT_RESULT_REPORT.ADDITIONAL_CONTENT}</p>
        <ParagraphOption data={data} isPreview={false} />
      </div>
      {isOpen !== -1 && <VideoPreview close={() => setIsOpen(-1)} media_files={data.media_files} data={data} firstOpen={isOpen} />}
    </>
  );
};

export default VideoOption;
